var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: {
          title: _vm.modalTitle,
          size: "xl",
          showCustomTitle: _vm.isEdittingLocked,
          static: true,
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "titleLine",
              fn: function () {
                return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
              },
              proxy: true,
            },
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-between bg-white pr-4 sm:pr-6 pb-3",
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900",
                        },
                        [_vm._v(" " + _vm._s(_vm.modalTitle) + " ")]
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "cursor-pointer flex items-center justify-center absolute top-3 right-3.5",
                      on: { click: _vm.closeModal },
                    },
                    [_c("CrossIcon", { staticClass: "h-3.5 w-3.5" })],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "form",
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ invalid, handleSubmit }) {
                              return [
                                _c(
                                  "ModalContent",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        !_vm.show
                                          ? {
                                              key: "actions",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex ml-auto",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass: "mr-3",
                                                        attrs: {
                                                          id: "savebutton3",
                                                          disabled:
                                                            invalid ||
                                                            _vm.isEdittingLocked ||
                                                            !_vm.selectedTagId ||
                                                            !_vm.selectedSourceId,
                                                          variant: "black",
                                                          size: "lg",
                                                          buttonText: "Save",
                                                          processing:
                                                            _vm.processing,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return handleSubmit(
                                                              _vm.onAdd
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "grid grid-cols-4 gap-4" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-span-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row-span-full" },
                                              [
                                                _c(
                                                  "FormGroup",
                                                  {
                                                    attrs: {
                                                      title: "",
                                                      name: "start_date",
                                                      errors: !_vm.selectedTagId
                                                        ? ["This is required"]
                                                        : [],
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "title",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-2 font-normal text-base leading-6",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-icon",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "*"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " Type "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("TagMultiselect", {
                                                      staticClass: "mb-5",
                                                      attrs: {
                                                        selectedTagId:
                                                          _vm.appliedTagId,
                                                      },
                                                      on: {
                                                        input: _vm.setTagId,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-4",
                                              },
                                              [
                                                _c(
                                                  "FormGroup",
                                                  {
                                                    attrs: {
                                                      title: "",
                                                      name: "source_field",
                                                      errors:
                                                        !_vm.selectedSourceId
                                                          ? ["This is required"]
                                                          : [],
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "title",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-2 font-normal text-base leading-6",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required-icon",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "*"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " Source "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("SourcesMultiselect", {
                                                      staticClass: "mb-5",
                                                      attrs: {
                                                        getcontainerStyle:
                                                          "customWidthInput",
                                                        selectedSourceId:
                                                          _vm.appliedSourceId,
                                                      },
                                                      on: {
                                                        input: _vm.setSourceId,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-4",
                                              },
                                              [
                                                _c(
                                                  "ValidationProvider",
                                                  {
                                                    attrs: {
                                                      name: "Profile link",
                                                    },
                                                  },
                                                  [
                                                    _c("FormGroup", {
                                                      attrs: {
                                                        title: "Profile Link",
                                                        name: "profile_link",
                                                        placeholder:
                                                          "Link to profile on sourcing platform (http://nameofsite.com)",
                                                        type: "text",
                                                        isIcon: false,
                                                        inputClass:
                                                          "fullwidthInput",
                                                        disabled:
                                                          _vm.isEdittingLocked,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .UpdateResourceInformation
                                                            .profileLink,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.UpdateResourceInformation,
                                                            "profileLink",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "UpdateResourceInformation.profileLink",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-4",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "mb-2 font-normal text-base leading-6",
                                                  },
                                                  [_vm._v("Duration")]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "flex" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-2 mt-2 mr-2 flex flex-row",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "required-icon",
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v(" From "),
                                                      ]
                                                    ),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        rules: "required_field",
                                                        vid: "start_date",
                                                        name: "Start date",
                                                        immediate:
                                                          !!_vm.projectActivity,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                              failed,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "FormGroup",
                                                                  {
                                                                    attrs: {
                                                                      errors:
                                                                        errors,
                                                                      name: "start_date",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "FormDatepicker",
                                                                      {
                                                                        attrs: {
                                                                          calendarClass:
                                                                            "bottom-11",
                                                                          invalid:
                                                                            failed,
                                                                          disabled:
                                                                            _vm.isEdittingLocked,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .UpdateResourceInformation
                                                                              .startDate,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.UpdateResourceInformation,
                                                                                "startDate",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "UpdateResourceInformation.startDate",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "m-2 flex flex-row",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "required-icon",
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v(" Till "),
                                                      ]
                                                    ),
                                                    _c("ValidationProvider", {
                                                      staticClass: "w-6/12",
                                                      attrs: {
                                                        rules:
                                                          "noBeforeDate:@start_date,@ongoing|required_field",
                                                        vid: "end_date",
                                                        name: "End Date",
                                                        immediate:
                                                          !!_vm.projectActivity,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function ({
                                                              errors,
                                                              failed,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "FormGroup",
                                                                  {
                                                                    attrs: {
                                                                      errors:
                                                                        errors,
                                                                      name: "end_date",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "FormDatepicker",
                                                                      {
                                                                        attrs: {
                                                                          calendarClass:
                                                                            "right-0 bottom-11",
                                                                          invalid:
                                                                            failed,
                                                                          disabled:
                                                                            _vm.isEdittingLocked,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .UpdateResourceInformation
                                                                              .endDate,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.UpdateResourceInformation,
                                                                                "endDate",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "UpdateResourceInformation.endDate",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row-span-full mt-6 flex",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("Checkbox", {
                                                      attrs: {
                                                        id: _vm
                                                          .showAvailabilityCheckbox
                                                          .id,
                                                        name: _vm
                                                          .showAvailabilityCheckbox
                                                          .name,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .showAvailabilityCheckbox
                                                            .selected,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.showAvailabilityCheckbox,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "showAvailabilityCheckbox.selected",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-span-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row-span-full" },
                                              [
                                                _c("ValidationProvider", {
                                                  attrs: {
                                                    name: "title",
                                                    rules: "required",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                          failed,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "FormGroup",
                                                              {
                                                                attrs: {
                                                                  id: "title",
                                                                  title: "",
                                                                  name: "type",
                                                                  placeholder:
                                                                    "Contractor's rate",
                                                                  disabled:
                                                                    _vm.isEdittingLocked,
                                                                  errors:
                                                                    errors,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "title",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-2 font-normal text-base leading-6",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "required-icon",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "*"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " Rate "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _c(
                                                                  "FormInputGroup",
                                                                  {
                                                                    attrs: {
                                                                      invalid:
                                                                        failed,
                                                                      disabled:
                                                                        _vm.isEdittingLocked,
                                                                      inputClasses:
                                                                        "pl-7",
                                                                      type: "number",
                                                                      prefix:
                                                                        "$",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .UpdateResourceInformation
                                                                          .rate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.UpdateResourceInformation,
                                                                            "rate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "UpdateResourceInformation.rate",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "row-span-6 mt-4",
                                              },
                                              [
                                                _c(
                                                  "FormGroup",
                                                  { attrs: { title: "Notes" } },
                                                  [
                                                    _c("FormTextarea", {
                                                      attrs: {
                                                        rows: 10,
                                                        placeholder:
                                                          "Additional details",
                                                        disabled:
                                                          _vm.isEdittingLocked,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .UpdateResourceInformation
                                                            .notes,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.UpdateResourceInformation,
                                                            "notes",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "UpdateResourceInformation.notes",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }